__turbopack_context__.v({
  "searchInputField": "collectionSearch-module-scss-module__lGkZ6q__searchInputField",
});
